import type { DXFUnit } from "building-types/assets/dxf";

const MM_PER_INCH = 25.4;

/**
 * Returns the factor to convert supported DXF units to inches.
 */
export function unitToInchFactor(unit: DXFUnit): number | null {
  switch (unit) {
    case "Inches":
      return 1;
    case "Millimeters":
      return 1 / MM_PER_INCH;
    default:
      return null;
  }
}
